/**
 * localStorage key set by our BugBug test suite (a `Run custom JavaScript` step in the
 * shared login component) to mark the session as an automated test run.
 */
export const E2E_STORAGE_KEY = 'ps-e2e'

/**
 * True when the current session is an automated E2E (BugBug) run.
 *
 * Used to opt automated runs out of things like PostHog session replay. Prefer this over
 * sniffing the test account's email — a human logged into the same account should behave
 * like any other user.
 */
export function isE2E(): boolean {
  try {
    return window.localStorage.getItem(E2E_STORAGE_KEY) === '1'
  } catch {
    // localStorage can throw (private mode, disabled storage) — never break the caller
    return false
  }
}
